import { Card } from '@mui/material';
import { Stack } from '@mui/system';
import { UNIT } from 'utils/StringDefinition';
import RowSelectComponent from '../share-components/RowSelect';
import SectionTitle from '../share-components/Tilte';

const Block041 = (props) => {
    const { blockData } = props;

    const listUpperFitting = [
        { id: 1, value: '塗装' },
        { id: 2, value: '溶融亜鉛メッキ' },
        { id: 3, value: '耐候性' },
    ];

    return (
        <>
            <Card
                component="main"
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0px 16px 0px 16px',
                }}
            >
                <Stack sx={{ width: '100%' }} spacing={0.25}>
                    <SectionTitle title="防錆仕様" />
                    <RowSelectComponent blockNumber="block004" name="aY4" description="上部工金具" initValue={blockData?.aY4?.value} listValue={listUpperFitting} unit={UNIT.description2} />

                    <RowSelectComponent blockNumber="block004" name="aY5" description="下部工金具" initValue={blockData?.aY5?.value} listValue={listUpperFitting} />

                    <RowSelectComponent
                        blockNumber="block004"
                        name="aY6"
                        description="主桁補強材"
                        initValue={blockData?.aY6?.value}
                        listValue={[
                            { id: 1, value: '塗装' },
                            { id: 2, value: '溶融亜鉛メッキ' },
                            { id: 3, value: '耐候性' },
                        ]}
                    />
                </Stack>
            </Card>
        </>
    );
};

export default Block041;
